import PopUpNewsletter from './PopUpNewsletter'
import PopUpMore18 from './PopUpMore18'
import PopUpCoupon from './PopUpCoupon'
import PopUpCart from './PopUpCart'

export default {
    'pop-up-newsletter': PopUpNewsletter,
    'pop-up-more-18': PopUpMore18,
    'pop-up-coupon': PopUpCoupon,
    'pop-up-cart': PopUpCart
}
